import request from '@/utils/service'

// 查询低消配置
export function getLowConsumptionConfig(data) {
  return request({
    url: '/lowConsumptionConfig/getLowConsumptionConfig',
    method: 'post',
    data
  })
}

// 更新低消配置
export function updateLowConsumptionConfig(data) {
  return request({
    url: '/lowConsumptionConfig/updateLowConsumptionConfig',
    method: 'post',
    data
  })
}
